import React, {Component} from 'react';

class Ppo extends Component{
	render(){
        const ppos = [...Array(70000)];
        console.log(ppos);
		return(
			<div>
				<h1 style={{'font-size': '28px', color: 'blue'}}>{ppos.map((a) => "뽀")} love rob</h1>
			</div>
		)
	}
}
export default Ppo;



// WEBPACK FOOTER //
// ./src/components/ppo.js